import { Smartphone, Route, Wrench, Receipt, Calculator, BarChart3 } from 'lucide-react';
import { Reveal } from './Reveal';

const ITEMS = [
  { icon: Smartphone, t: 'Application chauffeur', d: 'Rapport de journée, inspections, documents et heures, directement du téléphone.' },
  { icon: Route, t: 'Répartition', d: 'Les commandes, les arrêts et la position des camions au même endroit.' },
  { icon: Wrench, t: 'Atelier', d: "Bons de travail, pièces installées et historique de chaque véhicule." },
  { icon: Receipt, t: 'Facturation', d: 'Les factures partent des rapports déjà remplis, sans les retaper.' },
  { icon: Calculator, t: 'Comptabilité', d: 'Dépenses, factures et exports vers le logiciel de votre comptable.' },
  { icon: BarChart3, t: 'Analytics', d: 'Kilométrage, coûts et entretien, pour décider avec des faits.' },
];

export const Solutions = () => (
  <section className="bg-[#0B0F19] py-28 md:py-40" data-testid="solutions-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <Reveal className="max-w-3xl mb-16">
        <p className="text-xs uppercase tracking-[0.3em] text-amber-500 font-semibold mb-3">Les solutions</p>
        <h2 className="font-heading text-4xl sm:text-5xl uppercase font-bold tracking-tight text-white mb-5">Demander moins d'efforts à ceux qui créent déjà la valeur.</h2>
        <p className="text-lg text-slate-400">Chaque outil a une seule mission : que l'information saisie une fois serve partout.</p>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {ITEMS.map(({ icon: Icon, t, d }, i) => (
          <Reveal key={t} delay={i * 80}>
            <div className="h-full bg-[#111827] border border-white/5 rounded-2xl p-8 hover:-translate-y-1 hover:border-amber-500/40 transition-[transform,border-color] duration-300" data-testid={`solution-${i}`}>
              <div className="w-11 h-11 rounded-xl bg-amber-500/10 flex items-center justify-center mb-6"><Icon size={20} className="text-amber-400" /></div>
              <h3 className="text-white text-xl font-semibold mb-2">{t}</h3>
              <p className="text-slate-400 leading-relaxed">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
